module.exports = __webpack_public_path__ + "static/interstate-bold-78e19452211e358908808d8279061cef.otf";